import axios from 'axios';
import auth from "../auth/AuthProvider";
import { ApiPaths } from './ApiPaths'
import { RouteConstants } from "../../components/route/services/RouteConstants"

class HeartbeatApi {
    constructor() {
        let service = axios.create({});
        service.interceptors.response.use(this.handleSuccess, this.handleError);
        this.service = service;
    }

    handleSuccess = (response) => {
        return response;
    };

    handleError = (error) => {
        // don't handle 403 here, it'll be handled elsewhere
        if (error.response && error.response.status === 401) {
            if (auth.isAuthenticated()) {
                // we still have a token but CAS has revoked it, sign out
                auth.logout();
                return;
            }
        } else if (error.response && error.response.status === 403) {
            this.redirectTo(document, RouteConstants.UNAUTHORIZED);
            return;
        }
    };

    getRequestHeaders() {
        if (auth.isAuthenticated()) {
            return {
                Authorization: 'Bearer ' + auth.getAccessToken(),
                "api-version": "1.0"
            };
        }

        return { "api-version": "1.0" };
    }

    get() {
        return this.service.request({
            method: 'GET',
            headers: this.getRequestHeaders(),
            url: ApiPaths.HEARTBEAT,
            responseType: 'json'
        });
    }
}

const api = new HeartbeatApi();
export default api;